var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfinity = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.121 5.334c3.398 0 3.398 5.333 0 5.333-3.396 0-3.396-5.333 0-5.333Zm-8.237 0c-3.397 0-3.397 5.333 0 5.333s3.397-5.333 0-5.333Z",
  stroke: "currentColor",
  strokeWidth: 1.333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgInfinity;